<template>
  <v-container class="px-4 py-0" fluid>
    <v-row
      align="center"
      justify="space-between"
      class="mb-5"
      :class="isMobile ? 'flex-column gap-2 pt-2' : 'mx-8 table-styles pt-2'"
    >
      <!-- Mobile layout: buttons always on top -->
      <v-row
        v-if="isMobile"
        align="center"
        justify="center"
        class="w-100"
        no-gutters
      >
        <v-btn variant="plain" density="compact" :disabled="page === 1" class="px-2" @click="goToFirstPage">
          <v-icon>mdi-page-first</v-icon>
        </v-btn>
        <v-btn variant="plain" density="compact" :disabled="page === 1" class="px-2" @click="goToPreviousPage">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <span class="mx-2">{{ pageText }}</span>
        <v-btn variant="plain" density="compact" :disabled="page === totalPages" class="px-2" @click="goToNextPage">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn variant="plain" density="compact" :disabled="page === totalPages" class="px-2" @click="goToLastPage">
          <v-icon>mdi-page-last</v-icon>
        </v-btn>
      </v-row>

      <!-- Desktop: buttons + text in one line -->
      <v-row
        v-else
        align="center"
        justify="end"
        class="w-100"
        no-gutters
      >
        <span class="mr-2">Elementos por página:</span>
        <v-select
          v-model="itemsPerPage"
          :items="itemsPerPageOptions"
          density="compact"
          style="max-width: 90px;"
          class="mr-8"
          hide-details
          variant="outlined"
        />
        <span class="mr-4">{{ pageText }}</span>

        <v-btn variant="plain" density="compact" :disabled="page === 1" class="px-2" @click="goToFirstPage">
          <v-icon>mdi-page-first</v-icon>
        </v-btn>
        <v-btn variant="plain" density="compact" :disabled="page === 1" class="px-2" @click="goToPreviousPage">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn variant="plain" density="compact" :disabled="page === totalPages" class="px-2" @click="goToNextPage">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn variant="plain" density="compact" :disabled="page === totalPages" class="px-2" @click="goToLastPage">
          <v-icon>mdi-page-last</v-icon>
        </v-btn>
      </v-row>

      <!-- Mobile only: selector below -->
      <div v-if="isMobile" class="mt-2">
        <v-card-subtitle>Elementos por página</v-card-subtitle>
        <v-row class="w-100 justify-center mt-2" no-gutters>
          <v-select v-model="itemsPerPage" :items="itemsPerPageOptions" density="compact" hide-details variant="outlined" max-width="100px"/>
        </v-row>
      </div>
    </v-row>
  </v-container>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useLayoutStore } from '@/store/layout';
import { useLayoutField } from '@/composables/useLayoutField';
import { useDisplay } from 'vuetify';

const props = defineProps<{ moduleName: string }>();

const { mobile } = useDisplay();
const isMobile = computed(() => mobile.value);

const page = useLayoutField(props.moduleName, 'page');
const itemsPerPage = useLayoutField(props.moduleName, 'itemsPerPage');
const totalItems = useLayoutField(props.moduleName, 'totalItems');

const totalPages = computed(() =>
  Math.ceil(totalItems.value / itemsPerPage.value)
);

const pageText = computed(() =>
  `${(itemsPerPage.value * (page.value - 1)) + 1}–${Math.min(itemsPerPage.value * page.value, totalItems.value)} de ${totalItems.value}`
);

const itemsPerPageOptions = [5, 10, 25, 50, 100];

const goToFirstPage = () => {
  if (page.value > 1) page.value = 1;
};
const goToPreviousPage = () => {
  if (page.value > 1) page.value--;
};
const goToNextPage = () => {
  if (page.value < totalPages.value) page.value++;
};
const goToLastPage = () => {
  if (page.value < totalPages.value) page.value = totalPages.value;
};
</script>

<style scoped>
@media (max-width: 600px) {
  .flex-column {
    flex-direction: column !important;
  }
  .gap-2 {
    gap: 0.75rem;
  }
}
</style>

<script lang="ts">
export default {};
</script>